//import jQuery from "jquery";
//import "slick-carousel/slick/slick.css";
//import "slick-carousel/slick/slick-theme.css";
//import "slick-carousel";

const $ = jQuery;

export function initCardSlider() {
	const $slider = $(".afb-card-slider__elements");

	$slider.slick({
		dots: false,
		focusOnSelect: true,
		direction: "horizontal",
		infinite: false, // Disable infinite scroll
		speed: 300,
		variableWidth: true,
		// slidesToShow: 2,
		slidesToScroll: 1,
		rows: 0,
		centerMode: false,
		edgePadding: 0,
		prevArrow: $(".afb-card-slider__arrow-left"),
		nextArrow: $(".afb-card-slider__arrow-right"),
		responsive: [
			{
				breakpoint: 1025,
				settings: {
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToScroll: 1,
					prevArrow: $(".afb-card-slider__arrow-mobile-left"),
					nextArrow: $(".afb-card-slider__arrow-mobile-right"),
				},
			},
		],
	});
}
document.addEventListener("DOMContentLoaded", initCardSlider);
